<template>
  <div
    :class="mergedClasses"
    v-bind="passthroughAttrs"
  >
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdCardHeader',

  inheritAttrs: false,

  props: {
    headerBgVariant: {
      type: String,
      default: null
    },
    headerTextVariant: {
      type: String,
      default: null
    }
  },

  emits: [],

  computed: {
    headerClasses() {
      const classes = ['card-header'];

      if (this.headerBgVariant) classes.push(`bg-${this.headerBgVariant}`);
      if (this.headerTextVariant) classes.push(`text-${this.headerTextVariant}`);

      return classes;
    },

    mergedClasses() {
      return [this.$attrs.class, this.headerClasses].flat().filter(Boolean);
    },

    passthroughAttrs() {
      const { class: _class, ...attrs } = this.$attrs;

      return attrs;
    }
  }
});
</script>
